import React from "react";
import multiWorkspaces from "icons/multiWorkspaces.svg";
import UsersItemWorkspace from "layout/systemAdmin/users/UsersItemWorkspace";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import pen from "icons/pen-icon.svg";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { systemAdminDeleteUserModal } from "components/Modal/confModalTypes";
import Checkbox, {
  checkboxStates,
} from "@visiblethread/react-components/dist/components/Checkbox";
import userIcon from "icons/user_logged_in.svg";
import { userLogOut } from "slices/systemAdmin/actions/users";

const UsersItem = ({ user, systemAdminUsers }) => {
  const dispatch = useDispatch();

  return (
    <div
      className={`users__container__item ${
        user.workspaces !== null ? "" : "inactive"
      }`}
      data-testid="users-item"
    >
      <div className="users__container__item__user_name">
        <span>
          <img
            src={userIcon}
            alt="user logged in icon"
            className={
              !user.userLoggedIn && "users__container__item__logged_out"
            }
          />
        </span>
        <span title={user.username} data-testid="userItemUsername">
          {user.username}
        </span>
        {user.workspaces?.length > 1 ? (
          <img
            src={multiWorkspaces}
            alt="multiWorkspaces"
            data-testid="multiWorkspaceIcon"
          />
        ) : null}
      </div>
      <div className="users__container__item__workspaces">
        {user?.workspaces?.map((name) => (
          <UsersItemWorkspace workspaceName={name} />
        ))}
      </div>
      <span className="users__container__item__system_admin">
        <Checkbox
          state={
            user.systemAdmin ? checkboxStates.checked : checkboxStates.empty
          }
          disabled
          handleChange={() => {}}
          id="cbsystemadmin"
          value="system_admin_checkbox"
        />
      </span>
      <span
        title={user.firstName}
        className="users__container__item__first_name"
      >
        {user.firstName}
      </span>
      <span title={user.lastName} className="users__container__item__last_name">
        {user.lastName}
      </span>
      <span className="users__container__item__last_active">
        {user.lastActive ? user.lastActive : "Never Signed In"}
      </span>
      <span className="users__container__item__actions">
        <Button
          onClick={() => {
            dispatch(
              showModal(modalTypes.EDIT_USER, {
                currentUserName: user.username,
                currentFirstName: user.firstName,
                currentLastName: user.lastName,
                currentSystemAdmin: user.systemAdmin,
                onlyOneSystemAdmin: systemAdminUsers < 2,
              })
            );
          }}
          variant={buttonVariants.borderless}
          data-test="editMemberButton"
          content={<img src={pen} alt="pen" />}
        />
        <Button
          onClick={() => {
            dispatch(
              showModal(
                modalTypes.CONFIRMATION,
                systemAdminDeleteUserModal(user.username, dispatch)
              )
            );
          }}
          disabled={user.systemAdmin && systemAdminUsers < 2}
          variant={buttonVariants.borderless}
          dataTestId="removeMemberButton"
          content={<span>Delete User</span>}
        />
        <Button
          onClick={() => {
            dispatch(userLogOut(user.username));
          }}
          variant={buttonVariants.borderless}
          disabled={!user.userLoggedIn}
          dataTestId="logOutButton"
          content={<span>Logout</span>}
        />
      </span>
    </div>
  );
};

export default UsersItem;

UsersItem.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string.isRequired,
    workspaces: PropTypes.arrayOf(PropTypes.string),
    systemAdmin: PropTypes.bool.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    lastActive: PropTypes.string,
    userLoggedIn: PropTypes.bool.isRequired,
  }),
  systemAdminUsers: PropTypes.number.isRequired,
};
